export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref14017.01650a88.jpg";